import React from 'react';
import {
  ColumnDirective,
  ColumnsDirective,
  Filter,
  GridComponent,
  Inject,
  Page,
  Sort,
} from '@syncfusion/ej2-react-grids';
import type { DownloadAlertRow } from '../../../models/downloadAlert';

/** A grid-bound row: the API row plus precomputed display fields (company name). */
export interface DownloadAlertGridRow extends DownloadAlertRow {
  companyName: string;
}

export interface DownloadAlertsGridProps {
  rows: DownloadAlertGridRow[];
}

const GRID_PAGE_SIZE = 25;

export function DownloadAlertsGrid({ rows }: DownloadAlertsGridProps): React.ReactElement {
  return (
    <div className="bo-grid-wrap bo-card">
      <GridComponent
        dataSource={rows}
        allowPaging
        allowSorting
        allowFiltering
        pageSettings={{ pageSize: GRID_PAGE_SIZE, pageSizes: [10, 25, 50, 100] }}
        filterSettings={{ type: 'Menu' }}
        width="100%"
        height={520}
      >
        <ColumnsDirective>
          <ColumnDirective field="detectedAt" headerText="Detected (UTC)" width={180} />
          <ColumnDirective field="severity" headerText="Severity" width={110} />
          <ColumnDirective field="companyName" headerText="Company" width={180} />
          <ColumnDirective field="userId" headerText="User" width={180} />
          <ColumnDirective field="recordCount" headerText="Records" width={110} textAlign="Right" type="number" />
          <ColumnDirective field="responseSizeBytes" headerText="Bytes" width={130} textAlign="Right" type="number" />
          <ColumnDirective field="requestCount" headerText="Requests" width={110} textAlign="Right" type="number" />
          <ColumnDirective field="ipAddress" headerText="IP" width={140} />
          <ColumnDirective field="correlationId" headerText="Correlation" width={180} />
          <ColumnDirective field="resolvedAt" headerText="Resolved" width={180} />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter]} />
      </GridComponent>
    </div>
  );
}
